<template>
    <b-dropdown no-caret block :menu-class="{'dropdown-countries-list': !modifier , 'dropdown-countries-list--modifier dropdown-countries-list': modifier}">
        <template #button-content>
            <div class="dropdown contenido">
                <button class="contenido__button" :class="{'contenido__button--modifier': modifier}">
                    <span v-if="$root.pais_actual == ''" class="contenido__button-earth icon-earth"></span>
                    <img v-else class="contenido__button-img" :src="'/icons/multicolor/'+ $root.alias_pais.toLowerCase() + '.svg'" :alt="$root.paisOriginalName">
                    <span class="contenido__button-text" v-if="$root.pais_actual == ''">
                        {{textoDropdown}}
                    </span>
                    <span v-else>
                        <span class="contenido__button-text-default" v-if="modifier"> {{'Pais de contratación: '}} </span>
                        <span class="contenido__button-text-pais"> {{ $root.paisOriginalName }}</span>
                    </span>
                    <span class="contenido__button-down" :class="flechaDropdown"></span>
                </button>
            </div>
        </template>
        <div class="contenido">
            <span class="angle_dropdown"></span>
            <b-dropdown-item-button class="contenido__pais" v-for="pais in $root.paises" :key="pais.nombre" v-show="pais.nombre !== $root.paisOriginalName && !paises_deshabilitados.includes(pais.alias.toLowerCase())">                
                <div @click="setPaisContratacion(pais)" class="contenido__pais-centrado">
                    <div class="contenido__bandera">
                        <img
                            class="contenido__svg"
                            :src="'/img/banderas/listado_nombres/' + pais.alias + '.svg'"
                            :alt="pais.nombre"/>
                    </div>
                    <span class="contenido__text">{{ pais.nombre }}</span>
                    <span class="contenido__right icon-down"></span>
                </div>
            </b-dropdown-item-button>
        </div>
    </b-dropdown>
</template>

<script>
/* eslint-disable */
export default {
    name: 'DropdownCountries',
    data: () => ({
        flechaDropdown: 'icon-down',
        paises_deshabilitados: []
    }),
    props: {
        modifier: Boolean,
        textoDropdown: {
            required: false,
            default: 'Seleccionar país',
            type: String
        },
        paises_disabled_manual: String
    },
    methods: {
        setPaisContratacion(pais){
            this.$root.ruta_publica = pais.ruta_publica
            this.$root.pais_actual = pais.nombre
            this.$root.alias_pais = pais.alias.toLowerCase()
            this.$root.fecha_primer_proceso = pais.fecha_publicacion_primer_proceso
            this.$root.multiple_cuantias = pais.multiple_cuantias
            this.$root.paisSeleccionado = true
            this.$root.$emit('paisSeleccionado', pais)
            this.$root.$emit('getMonedas');
            if (!this.modifier) {
                window.location.href = '/'+sinTildes(this.$root.ruta_publica).toLowerCase().trim()
            }
        }
    },
    mounted() {
        if (!this.modifier) {
            this.$root.paisSeleccionado = true
        }

        this.$root.$on('bv::dropdown::show', bvEvent => {
            if (bvEvent.type === 'show' && bvEvent.target.className === 'dropdown-menu dropdown-countries-list') {
                this.flechaDropdown = 'icon-up'
            }
        })
        this.$root.$on('bv::dropdown::hide', bvEvent => {
            if (bvEvent.type === 'hide' && bvEvent.target.className === 'dropdown-menu dropdown-countries-list show') {
                this.flechaDropdown = 'icon-down'
            }
        })

        if (this.paises_disabled_manual) {
            this.paises_deshabilitados = this.paises_disabled_manual.split(',')   
        }
    }
}
</script>

<style lang="scss" scoped>

/** Estilos para el dropdown de paises para todas las zonas**/
.contenido{
    &__button{
        margin-left: 10px;
        border-radius: 36px;
        background: white;
        padding: 10px 20px;
        border: 0px;
        color: #686868;
        font-size: 0.88rem;
        font-weight: bold;
        font-family: Poppins;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:hover{
            background: rgba(#9C9B9B, 0.1);
        }
        &-earth{
            font-size: 1.2rem;
            margin-right: 15px;
        }
        &-img{
            width: 22px;
            margin-right: 15px;
        }
        &-text{
            margin-right: 15px;
        }
        &-down{
            font-size: 0.44rem;
            margin-left: 10px;
        }
    }
}

.contenido{
    &__angle{
        position: absolute;
        top: -15px;
        right: 8px;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-right: 17px solid #fff;
        height: 0;
        width: 0;
        -webkit-filter: drop-shadow(-4px 0 2px rgba(52,45,45,.1));
        filter: drop-shadow(-4px 0 2px rgba(52,45,45,.1));
        border-bottom-right-radius: 2px;
        display: inline-block;
        transform: rotate(90deg);
    }
    &__pais{
        display: block;
        &-centrado{
            display: flex;
            justify-content: space-between;
            align-items: center;
            max-width: 140px;
            width: 100%;
        }
    }
    &__svg{
      margin-right: 5px;
      width: 35px;
    }
    &__bandera{
        font-size: 1.5rem;
    }
    &__text{
        text-align: left;
    }
    &__right {
        font-size: 0.44rem;
        transform: rotate(270deg);
    }
}

.dropdown-countries-list--modifier .contenido__bandera {
    font-size: 1rem;
}

.dropdown-countries-list--modifier .contenido__svg {
    width: 30px;
}

@media(max-width: 992px){
    .contenido{
        &__pais{
            &-centrado{
                // min-width: 100%;
            }
        }
        &__button{
            padding: 10px;
            &-img{
                margin-right: 0px;
            }
            &-earth{
                margin-right: 8px;
            }
            &-text{
                display: none;
                &-pais{
                    display: none;
                }
            }
        }
    }
}

@media(max-width: 600px){
    .contenido{
        &__button{
            padding: 10px 12px;
            margin-left: 5px;
        }
    }
}

/** Estilos del dropdown para la segunda forma**/

.contenido {
    &__button--modifier{
        font-size: 1rem;
        border: 2px solid #D4D4D4;
        padding: 11px 18px;
        margin-left: 0;
        font-weight: inherit;
        font-family: Roboto;
        &:hover{
            background: transparent;
        }
        .icon-earth{
            font-size: 1.188rem;
        }
    }
}

@media(max-width: 992px){
    .contenido{
        &__button--modifier{ 
            .contenido__button-text{
                display: flex;
            }
            .contenido__button-text-default{
                display: none;
            }
        }
    }
    .dropdown-countries-list--modifier {
        .contenido{
            &__pais{
                &-centrado{
                    // min-width: 100%;
                }
            }
        }
    }
}


</style>